import React from "react";

import { LOGO_ASSETS } from "../../constants/logos";

export interface LogoProps {
  /**
   * Type of logo to display
   * - 'horizontal': Full horizontal logo (for login, expanded sidebar)
   * - 'logomark': Compact logomark (for collapsed sidebar)
   */
  variant: "horizontal" | "logomark";
  /**
   * Custom className for styling
   */
  className?: string;
  /**
   * Height of the logo (width will scale proportionally)
   */
  height?: number | string;
  /**
   * Width of the logo (height will scale proportionally)
   */
  width?: number | string;
  /**
   * Alt text for accessibility
   */
  alt?: string;
  /**
   * Custom inline styles
   */
  style?: React.CSSProperties;
}

/**
 * Logo component that displays either the horizontal logo or logomark
 * Use horizontal logo for login pages and expanded sidebars
 * Use logomark for collapsed sidebars
 */
export const Logo: React.FC<LogoProps> = ({
  variant,
  className = "",
  height,
  width,
  alt,
  style: customStyle,
}) => {
  const logoConfig = LOGO_ASSETS[variant];

  const computedStyle: React.CSSProperties = {};
  if (height)
    computedStyle.height = typeof height === "number" ? `${height}px` : height;
  if (width)
    computedStyle.width = typeof width === "number" ? `${width}px` : width;

  return (
    <img
      src={logoConfig.svg}
      alt={alt || logoConfig.alt}
      className={className}
      style={{ ...computedStyle, ...customStyle }}
    />
  );
};

Logo.displayName = "Logo";
